var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.6557C28.0021 17.4255 27.1826 20.1338 25.6451 22.4377C24.1076 24.7417 21.9212 26.5378 19.3626 27.5987C16.804 28.6597 13.9881 28.9379 11.2714 28.398C8.55466 27.8582 6.0591 26.5246 4.10051 24.566C2.14192 22.6074 0.808331 20.1118 0.268484 17.3951C-0.271363 14.6784 0.00679623 11.8625 1.06777 9.30392C2.12874 6.74532 3.92483 4.55893 6.22878 3.02142C8.53273 1.4839 11.241 0.664363 14.0108 0.666508C17.7201 0.66938 21.2766 2.14416 23.8995 4.76701C26.5223 7.38986 27.9971 10.9464 28 14.6557Z",
    fill: "#F24E68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30859 21.8672H18.0725",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0725 21.8674H8.30859L14.3588 8.73975H34.9138L40.9753 21.8674H31.2001",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2116 21.8672C31.1414 23.5609 30.4191 25.1619 29.1958 26.3355C27.9726 27.5091 26.343 28.1644 24.6478 28.1644C22.9526 28.1644 21.323 27.5091 20.0998 26.3355C18.8765 25.1619 18.1542 23.5609 18.084 21.8672",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9753 21.8672V31.4843C40.9753 32.4153 40.6054 33.3082 39.9471 33.9666C39.2887 34.6249 38.3958 34.9948 37.4648 34.9948H11.8304C10.8983 34.9948 10.0042 34.6253 9.34408 33.9673C8.68395 33.3093 8.31158 32.4164 8.30859 31.4843V21.8672",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRed);
export default __webpack_public_path__ + "static/media/downloadRed.fc64b08fac6154bc5108d797a5a59b50.svg";
export { ForwardRef as ReactComponent };